'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactI18next = require('react-i18next');

var _lodash = require('lodash');

var _reactModal = require('react-modal');

var _reactModal2 = _interopRequireDefault(_reactModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function footerIconList(props) {
    var _useTranslation = (0, _reactI18next.useTranslation)('footer'),
        t = _useTranslation.t;

    var _useState = (0, _react.useState)(false),
        _useState2 = _slicedToArray(_useState, 2),
        showPopup = _useState2[0],
        setShowPopup = _useState2[1];

    var _useState3 = (0, _react.useState)(null),
        _useState4 = _slicedToArray(_useState3, 2),
        popupContent = _useState4[0],
        setPopupContent = _useState4[1];

    var _useState5 = (0, _react.useState)(window.innerWidth),
        _useState6 = _slicedToArray(_useState5, 2),
        screenSize = _useState6[0],
        setScreenSize = _useState6[1];

    window.addEventListener('resize', function () {
        setScreenSize(window.innerWidth);
    });

    (0, _react.useEffect)(function () {
        setTimeout(function () {
            if (window.location.hash.toLowerCase() === '#wechat') {
                document.getElementById('icon-wechat').click();
            }
        }, 2000);
    }, []);

    var iconList = function iconList() {
        return !(0, _lodash.isEmpty)(t("footerIcon", { returnObjects: true })) && t("footerIcon", { returnObjects: true }).map(function (obj, key) {
            return _react2.default.createElement(
                'a',
                {
                    className: 'mx-2 foot-link foot-icon',
                    key: key,
                    target: "_blank",
                    href: props.returnFullURL(obj.url),
                    id: obj.icon,
                    onClick: function onClick(e) {
                        e.preventDefault();
                        if (!(0, _lodash.isEmpty)(obj.img)) {
                            console.log(obj);
                            setShowPopup(true);
                            setPopupContent({
                                url: obj.img
                            });
                        } else {
                            props.onURLClick(obj.url, 'footerIcon');
                        }
                    }
                },
                _react2.default.createElement(
                    'div',
                    { className: 'icon-wrapper d-flex justify-content-center align-items-center' },
                    _react2.default.createElement('span', { className: 'icon ' + obj.icon })
                )
            );
        });
    };

    return _react2.default.createElement(
        'div',
        { className: 'col-12 col-lg-5 order-1 order-lg-2 px-0' },
        _react2.default.createElement(
            'div',
            { className: 'd-flex justify-content-lg-end justify-content-start mb-lg-0 mb-4 follow-us' },
            iconList()
        ),
        _react2.default.createElement(
            _reactModal2.default,
            {
                isOpen: showPopup,
                style: {
                    overlay: {
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        zIndex: 9999
                    },
                    content: {
                        backgroundColor: 'rgb(0, 80, 139)',
                        maxWidth: '80vh',
                        margin: 'auto',
                        height: screenSize < 992 ? '80vh' : 'auto'
                    }
                },
                shouldFocusAfterRender: false
            },
            _react2.default.createElement(
                'div',
                { style: { position: 'relative' } },
                _react2.default.createElement(
                    'div',
                    { style: { cursor: 'pointer' } },
                    _react2.default.createElement('div', {
                        style: {
                            color: 'white',
                            fontSize: 30
                        },
                        onClick: function onClick() {
                            setShowPopup(false);
                            setPopupContent(null);
                        },
                        className: 'footer-close'
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { style: { paddingTop: 40 } },
                    !(0, _lodash.isEmpty)(popupContent) && !(0, _lodash.isEmpty)(popupContent.url) && _react2.default.createElement('img', { src: popupContent.url, style: { width: '100%' } })
                )
            )
        )
    );
}

exports.default = footerIconList;